import React, { useContext } from 'react';
import AppContext from './AppContext';
import PokedexSpriteGridCell from './PokedexSpriteGridCell';

function PokedexSpriteGrid() {
  const { filteredSpeciesIds: speciesIds } = useContext(AppContext);
  const sprites = speciesIds.map((speciesId) => <PokedexSpriteGridCell key={`sprite-cell-${speciesId}`} speciesId={speciesId} />);

  return (
    <div className="block flex flex-wrap gap-1 min-w-full overflow-auto max-h-screen">
      {sprites}
    </div>
  );
}

export default PokedexSpriteGrid;
